import request from "@/utils/request";

/**
 * Get hotel basic info (name, brand, color) by hotelNo
 */
export function getHotelInfo(hotelNo) {
  return request({
    url: `/api/schedule/hotelInfo/${hotelNo}`,
    method: "get",
  });
}

/**
 * Get department list for a hotel property by hotelNo
 */
export function getDepartments(hotelNo) {
  return request({
    url: `/api/schedule/departments/${hotelNo}`,
    method: "get",
  });
}

/**
 * Submit a schedule / time-off request
 */
export function submitScheduleRequest(data) {
  return request({
    url: "/api/schedule/request",
    method: "post",
    data,
  });
}

export function checklistLogin(data) {
  return request({
    url: "/api/common/user/hotel_dept_name/checkListLogin",
    method: "post",
    data,
  });
}

export function getCurrentScheduleUser(token) {
  return request({
    url: "/api/common/user/current_user",
    method: "get",
    headers: {
      HTTOKEN: token,
    },
  });
}

export function getScheduleUserInfo(hotelNo, userId) {
  return request({
    url: `/api/schedule/user/${hotelNo}/${userId}`,
    method: "get",
  });
}

export function scheduleRecordList(data) {
  return request({
    url: "/api/schedule/records",
    method: "post",
    data,
  });
}
